export default __webpack_public_path__ + "797dd4161b3ce189a47ff42269e9d5a6.svg";